import type { ComponentProps } from 'react';

import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import { cn } from '@repo/lib/cn';

export function HoverCard(hoverCardProps: ComponentProps<typeof HoverCardPrimitive.Root>) {
  const { openDelay = 200, closeDelay = 100, ...props } = hoverCardProps;
  return <HoverCardPrimitive.Root data-slot="hover-card" openDelay={openDelay} closeDelay={closeDelay} {...props} />;
}

export function HoverCardTrigger(hoverCardTriggerProps: ComponentProps<typeof HoverCardPrimitive.Trigger>) {
  return <HoverCardPrimitive.Trigger data-slot="hover-card-trigger" {...hoverCardTriggerProps} />;
}

export function HoverCardContent(
  hoverCardContentProps: ComponentProps<typeof HoverCardPrimitive.Content> & {
    disablePortal?: boolean;
  }
) {
  const { className, align = 'center', sideOffset = 8, disablePortal = false, ...props } = hoverCardContentProps;

  const content = (
    <HoverCardPrimitive.Content
      data-slot="hover-card-content"
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'border bg-popover text-popover-foreground data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0 data-closed:zoom-out-95 data-open:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 flex flex-col gap-2.5 rounded-lg p-3 text-sm shadow-md duration-150 z-50 w-72 origin-(--radix-hover-card-content-transform-origin) outline-0',
        className
      )}
      {...props}
    />
  );

  if (disablePortal) {
    return content;
  }

  return <HoverCardPrimitive.Portal>{content}</HoverCardPrimitive.Portal>;
}
